export function AchievementsDetails() {
  return (
    <div className="space-y-8">
      <h2 className="text-2xl font-bold text-gray-900">Achievement Details</h2>
      
      <div className="bg-white rounded-lg p-8 border border-gray-200">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Achievement Title */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Achievement Title <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="e.g., Dean's List, Science Fair Winner"
            />
          </div>

          {/* Achievement Type */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Achievement Type <span className="text-red-500">*</span>
            </label>
            <select
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            >
              <option value="">Select achievement type</option>
              <option value="academic">Academic Excellence</option>
              <option value="sports">Sports Achievement</option>
              <option value="arts">Arts & Culture</option>
              <option value="leadership">Leadership</option>
              <option value="community">Community Service</option>
              <option value="research">Research</option>
              <option value="other">Other</option>
            </select>
          </div>

          {/* School/Institution */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              School/Institution <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Enter school or institution name"
            />
          </div>

          {/* Date Achieved */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Date Achieved <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            />
          </div>

          {/* Grade Level/Year */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Grade Level/Year
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="e.g., 10th Grade, Junior Year"
            />
          </div>

          {/* Recognition Level */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Recognition Level
            </label>
            <select
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            >
              <option value="">Select recognition level</option>
              <option value="school">School Level</option>
              <option value="district">District Level</option>
              <option value="state">State Level</option>
              <option value="national">National Level</option>
              <option value="international">International Level</option>
            </select>
          </div>

          {/* Location */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Location <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="City, State/Province, Country"
            />
          </div>

          {/* Award/Certificate Number */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Award/Certificate Number
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Enter certificate or award number"
            />
          </div>
        </div>
      </div>
    </div>
  )
} 